module.exports = __webpack_public_path__ + "img/Te whare tapa wha.0fa28fc8.png";